"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var n = require("polished/lib/color/shade"),
  a = require("./colors-c0f39aa2.js");
function d(n) {
  return n && "object" == _typeof(n) && "default" in n ? n : {
    "default": n
  };
}
var r = d(n),
  c = {
    pcgGold: "\n  background: rgb(189, 162, 99);\n  background: linear-gradient(\n    90deg,\n    ".concat(r["default"](.05, a.DEFAULT_COLORS.brand.pcg.gold1), " 0%,\n    ").concat(r["default"](.05, a.DEFAULT_COLORS.brand.pcg.gold2), " 50%,\n    ").concat(r["default"](.05, a.DEFAULT_COLORS.brand.pcg.gold1), "\n  );\n"),
    pcgGoldHover: "\n  background: rgb(189, 162, 99);\n  background: linear-gradient(\n    90deg,\n    ".concat(r["default"](.05, a.DEFAULT_COLORS.brand.pcg.gold1), " 0%,\n    ").concat(r["default"](.05, a.DEFAULT_COLORS.brand.pcg.gold2), " 50%,\n    ").concat(r["default"](.05, a.DEFAULT_COLORS.brand.pcg.gold1), "\n  ); // TODO: darken RGB values programatically\n"),
    pcgBlue: "\n  background: rgb(2, 0, 36);\n  background: linear-gradient(\n    193deg,\n    ".concat(r["default"](.05, a.DEFAULT_COLORS.brand.pcg.darkBlue1), " 0%,\n    ").concat(r["default"](.05, a.DEFAULT_COLORS.brand.pcg.darkBlue2), " 50%,\n    ").concat(r["default"](.05, a.DEFAULT_COLORS.brand.pcg.darkBlue1), "\n  );\n  ")
  };
exports.gradients = c;